'use client';

import { useAuthStore } from 'lib/stores/authStore';

import { useMarginWaitlistStatusForUser } from './marginWaitlistApi';

export type PerpsWaitlistAccessSnapshot = {
    isLoggedIn: boolean;
    userId: string | null;
    canStartOnboarding: boolean;
    hasReleasedAccess: boolean;
    completedFcmApplication: boolean;
    isLoading: boolean;
    isRefreshing: boolean;
    isError: boolean;
};

export function usePerpsWaitlistAccessSnapshot(): PerpsWaitlistAccessSnapshot {
    const isLoggedIn = useAuthStore((s) => s.isLoggedIn);
    const userId = useAuthStore((s) => s.userId);

    const { data: status, isFetching, isLoading, isError } = useMarginWaitlistStatusForUser();

    return {
        isLoggedIn,
        userId,
        canStartOnboarding: status?.can_start_onboarding === true,
        // The public waitlist is retired, so anonymous visitors are always released.
        // Logged-in release stays driven by the per-entry BE waitlist status.
        hasReleasedAccess: !isLoggedIn || status?.beta_unlocked === true,
        completedFcmApplication: status?.fcm_application_completed === true,
        isLoading: isLoggedIn && isLoading,
        isRefreshing: isLoggedIn && isFetching,
        isError: isLoggedIn && isError,
    };
}

export function useHasPerpsWaitlistAccess(): boolean {
    return usePerpsWaitlistAccessSnapshot().hasReleasedAccess;
}
